import { useTranslation } from 'react-i18next';

interface ReceiptHeaderProps {
  restaurantName: string;
  branchName?: string;
  branchAddress?: string;
  branchPhone?: string;
  tableNumber?: string | null;
  orderNumber: string;
  orderTime: Date;
}

export function ReceiptHeader({
  restaurantName,
  branchName,
  branchAddress,
  branchPhone,
  tableNumber,
  orderNumber,
  orderTime,
}: ReceiptHeaderProps) {
  const { i18n } = useTranslation('customer');
  const isRTL = i18n.language === 'ar';

  const shortOrderId = orderNumber.substring(0, 8).toUpperCase();
  const formattedTime = orderTime.toLocaleString(i18n.language === 'ar' ? 'ar-EG' : 'en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className="text-center space-y-2">
      {/* Restaurant Name */}
      <h1 className="text-xl font-bold uppercase">{restaurantName}</h1>

      {/* Branch Info */}
      {branchName && (
        <div className="space-y-1">
          <p className="font-semibold">{branchName}</p>
          {branchAddress && <p className="text-xs text-muted-foreground">{branchAddress}</p>}
          {branchPhone && <p className="text-xs text-muted-foreground">{branchPhone}</p>}
        </div>
      )}

      {/* Divider */}
      <div className="border-t border-dashed border-gray-400 my-2" />

      {/* Order Info */}
      <div className="space-y-1">
        {tableNumber && (
          <p className="text-sm">
            {isRTL ? `طاولة ${tableNumber}` : `Table ${tableNumber}`}
          </p>
        )}
        <p className="text-xs text-muted-foreground">{formattedTime}</p>
        <p className="text-lg font-bold">
          {isRTL ? `الطلب #${shortOrderId}` : `Order #${shortOrderId}`}
        </p>
      </div>
    </div>
  );
}



